/** True when running on the Vite dev server (`yarn dev`), not deployed envs. */
export const isViteDevServer = () =>
  Boolean(process.env.VITE_HOST) || window.location.port === '3000';
